import React from 'react'

function Button({text, type, openType, hrefLink='none'}) {
  return (
    <a target={openType} href={hrefLink} className={`button ${type}`}>{text}</a>
  )
}

export default Button